import { button,typography } from "@dillon/Utilities/styleguide";
import { colorPalette } from "@dillon/Utilities/variables";
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const setPreStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPreStyleGuideTheme({
        button,
        colors: colorPalette,
        typography,
    });
};

export default setPreStyles;
